import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import preloader from './modules/preloader'

Vue.use(Vuex)
export const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    preloader
  }
})